var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-select',{attrs:{"value":_vm.value,"filterable":true,"clearable":true},on:{"input":_vm.on_select}},_vm._l((_vm.external_numbers),function(option){return _c('i-option',{key:option.id,attrs:{"value":option.id,"label":option.number}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }